<template>
  <div class="template">
    <div class="top-row">
      <el-button
        style="float: left"
        type="primary"
        size="medium"
        icon="el-icon-refresh"
        @click="handleReset"
        >重置为系统默认</el-button
      >
      <div class="btns">
        <el-button
          type="danger"
          size="medium"
          icon="el-icon-delete"
          :disabled="selectedIds.length == 0"
          @click="handleRemove()"
          >批量删除</el-button
        >
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-plus"
          @click="show = true"
          >新增模板</el-button
        >
      </div>
    </div>

    <el-table
      :data="list"
      @selection-change="handleSelectionChange"
      stripe
      class="list"
    >
      <el-table-column align="center" type="selection" width="55" />
      <el-table-column prop="name" label="文件名"> </el-table-column>
      <el-table-column
        prop="createTime"
        label="上传时间"
        width="200"
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" size="small">
            <a :href="row.url" :download="row.name" target="_blank">下载</a>
          </el-button>
          <el-button
            size="mini"
            type="text"
            style="color: #f56c6c"
            @click="handleRemove(row.templateId)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      classv="template-dialog"
      title="上传模板"
      :visible.sync="show"
      width="35%"
      center
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="80px"
        size="small"
      >
        <el-form-item label="文件名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="上传文件" prop="url" style="text-align: left">
          <uploadFile
            @success="uploadSuccess"
            :fileType="fileType"
            style="display: inline-block"
          >
            <div class="uploader">
              <i class="el-icon-document" v-if="form.url"></i>
              <i class="el-icon-plus" v-else></i>
            </div>
          </uploadFile>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="show = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleAdd"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  templateList,
  saveTemplate,
  delTemplate,
  resetList,
} from "@/api/projectPractice/roadshow";
import { status } from "@/api/projectPractice/common";
import uploadFile from "@/components/uploadFile";
export default {
  components: {
    uploadFile,
  },
  data() {
    return {
      list: [],
      selectedIds: [],
      show: false,
      form: {
        name: "",
        url: "",
      },
      rules: {
        name: { required: true, message: "请输入文件名称", trigger: "blur" },
        url: { required: true, message: "请上传文件", trigger: "blur" },
      },
      fileType: [],
    };
  },
  created() {
    this.getStatus();
  },
  watch: {
    show(val) {
      if (!val) this.form = this.$options.data().form;
    },
  },
  methods: {
    // 项目状态
    getStatus() {
      status({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          if (!res.data.lyTemplateInit) {
            this.setFn();
          } else this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 模板列表
    getList() {
      this.$loading.show();
      templateList({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 上传成功
    uploadSuccess(file) {
      this.form.url = file.url;
      this.$refs.form.clearValidate("url");
    },
    // 新增模板
    handleAdd() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.classId = this.$route.query.id;
          saveTemplate(this.form).then((res) => {
            if (res.code == 0) {
              this.getList();
              this.show = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map((item) => item.templateId);
    },
    // 删除模板
    handleRemove(templateId) {
      this.$msgbox({
        title: "提示",
        message: "您确定要删除该模板？",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            delTemplate(templateId || this.selectedIds)
              .then(() => {
                this.$message.success("删除成功");
                this.getList();
              })
              .finally(() => {
                done();
                instance.confirmButtonLoading = false;
              });
          } else {
            done();
          }
        },
      });
    },
    // 重置
    handleReset() {
      this.$confirm(`确定要重置为系统默认吗?`, {
        type: "warning",
      })
        .then(() => {
          this.setFn();
        })
        .catch(() => {});
    },
    setFn() {
      this.$loading.show();
      resetList(this.$route.query.id).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.getList();
          this.$message.success("路演模板已初始化");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.template {
  .top-row {
    margin-bottom: 10px;
    overflow: hidden;
    .btns {
      float: right;
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
  .uploader {
    width: 104px;
    height: 104px;
    line-height: 104px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border-color: teal;
    }

    .el-icon-plus {
      font-size: 28px;
      color: #8c939d;
      width: 104px;
      height: 104px;
      line-height: 104px;
      text-align: center;
    }
    .el-icon-document {
      font-size: 30px;
    }
  }
}
</style>